import { AppBar as MUIAppBar, AppBarProps as MUIAppBarProps } from '@mui/material';

export interface AppBarProps extends MUIAppBarProps {}

export const AppBar = MUIAppBar;
